import script from "./CpfCnpjInput.vue?vue&type=script&setup=true&lang=js"
export * from "./CpfCnpjInput.vue?vue&type=script&setup=true&lang=js"

import "./CpfCnpjInput.vue?vue&type=style&index=0&id=58155542&scoped=true&lang=css"
import "./CpfCnpjInput.vue?vue&type=style&index=1&id=58155542&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58155542"]])

export default __exports__